// MainLeftSidePanel
import { Box, Popover, Typography, Button, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {  layoutLightGreenColor } from "../../data/contents";
import LsService, { storageKey } from "../../services/localstorage";

const DNRMainRightHeaderBar = ({ userDetails }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    LsService.removeItem(storageKey);
    navigate("/");
  };

  return (
    <Box
      sx={{
        height: "6vh",
        position: "fixed",
        p: 1,
        top: 0,
        right: 0,
        zIndex: 3,
        // bgcolor: "grey",
      }}
    >
      <Box sx={{ mr: 1, display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          onClick={(e) => handleAvatarClick(e)}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              bgcolor: layoutLightGreenColor,
              color: "#fff",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 22,
              cursor: "pointer",
            }}
          >
            {userDetails.role.slice(0, 1).toUpperCase()}
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column", cursor: "pointer" }}
          >
            <span style={{ fontWeight: "bold", fontSize: 18 }}>
              {userDetails.username}
            </span>
            <span
              style={{
                fontSize: 12,
                color: "gray",
              }}
            >
              {userDetails.role}
            </span>
          </Box>
        </Box>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            sx: { p: 2, minWidth: 220, borderRadius: 3 },
          }}
        >
          <Typography fontWeight="bold" fontSize="1rem" mb={0.5}>
            {userDetails.username}
          </Typography>
          <Typography fontSize="0.9rem" color="text.secondary" mb={1}>
            Role: {userDetails.role}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Button
            fullWidth
            variant="text"
            color="error"
            onClick={onLogoutClick}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              fontWeight: "bold",
            }}
            startIcon={<span style={{ fontSize: 18 }}>↩</span>}
          >
            Log out
          </Button>
        </Popover>
      </Box>
    </Box>
  );
};

export default DNRMainRightHeaderBar;
